import { render, staticRenderFns } from "./Osa016.vue?vue&type=template&id=7e8e6aaa&scoped=true"
var script = {}
import style0 from "./Osa016.vue?vue&type=style&index=0&id=7e8e6aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8e6aaa",
  null
  
)

export default component.exports